import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DockModule } from 'primeng/dock';
import { ElementService } from '../../services/builder/new-element.service';
import { ToastModule } from 'primeng/toast';
import { DragDropService } from '../../services/builder/drag-drop.service';
import { BuilderStatusService } from '../../services/builder/builder-status.service';
import { RulesService } from '../../services/builder/rules.service';
import { CompilingDashboardService } from '../new-compiling-dashboard/compiling-dashboard.service';
import { ModuleBuilderComponent } from '../new-builder-dashboard/module-builder/module-builder.component';
import { PlaygroundComponent } from '../new-builder-dashboard/playground/playground.component';

@Component({
  selector: 'lib-builder-dashboard-dialog',
  templateUrl: './builder-dashboard-dialog.component.html',
  styleUrls: ['./builder-dashboard-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    DockModule,
    DragDropModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    ToastModule,
    ModuleBuilderComponent,
    PlaygroundComponent,
  ],
  providers: [
    BuilderStatusService,
    ElementService,
    DragDropService,
    RulesService,
    CompilingDashboardService,
  ],
})
export class BuilderDashboardDialogComponent {
  protected elementService = inject(ElementService);
  protected dragDropService = inject(DragDropService);
  protected builderStatus = inject(BuilderStatusService);
}
